import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
	selector: "app-sticky-header",
	templateUrl: "./sticky-header.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ["./sticky-header.component.scss"]
})
export class StickyHeaderComponent {
}
